













































import { BvTableField } from 'bootstrap-vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    exportingToCsvStatus: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Export'
    },
    exportData: {
      type: Array,
      required: true
    },
    fields: {
      type: Array as PropType<Array<{ key: string } & BvTableField>>,
      required: true
    },
    useLabels: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false,
      delimiter: ',',
      wrapFieldsInQuotes: false,
      delimiterOptions: [
        { value: ',', text: 'Comma' },
        { value: '|', text: 'Pipe' },
        { value: ';', text: 'Semicolon' },
        // tslint:disable-next-line:quotemark
        { value: "'", text: 'Apostrophe' }
      ]
    };
  },
  computed: {
    labelMappings(this: any) {
      return (this.fields as Array<{ key: string } & BvTableField>).reduce((dict, field) => ({ ...dict, [field.key]: field.label }), {});
    }
  },
  methods: {
    csvExport(this: any) {
      try {
        if (this.exportData?.length && this.fields) {
          const visibleColumns = this.fields.map((a: any) => a.key);

          const visibleColumnData = this.exportData.map((filteredItem: any) =>
            Object.keys(filteredItem)
              .filter((key) => visibleColumns.includes(key))
              .reduce((obj: any, key: any) => {
                obj[key] = filteredItem[key];
                return obj;
              }, {})
          );

          if (visibleColumnData?.length > 0) {
            const exportWithQuotes = this.wrapFieldsInQuotes ? '"' : '';
            const exportHeaders = Object.keys(visibleColumnData[0])
              .map((key) => (this.useLabels ? this.labelMappings[key] : key))
              .join(this.delimiter);
            const exportRows = visibleColumnData.map((item: any) => `${exportWithQuotes}${Object.values(item).join(`${exportWithQuotes}${this.delimiter}${exportWithQuotes}`)}${exportWithQuotes}`);
            const csvContent = [exportHeaders, ...exportRows].join('\n').replace(/(^\[)|(\]$)/gm, '');

            const blob = new Blob([csvContent], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'export.csv';
            link.click();
            window.URL.revokeObjectURL(url);
          }
        }
        this.$emit('export-successful');
      } catch (error) {
        this.$log('Error exporting table data to a CSV file', error);
        this.$emit('export-failed', error);
      }
    },
    onExportToCsvSubmit(this: any) {
      if (this.exportingToCsvStatus) {
        this.csvExport();
      }
    },
    OnCancelClicked(this: any) {
      this.$emit('export-cancelled');
    }
  },
  watch: {
    exportingToCsvStatus(this: any) {
      this.showModal = this.exportingToCsvStatus;
    }
  }
});
